<div *ngIf="type=='datewise very Briefly'">
  <div id="print-section" style="margin-top:50px;margin-left:15px;">
    <table class="table" style="border-collapse: collapse; width: 100%; border: 1px solid black;">
      <thead>
        <!-- Header section -->

        <tr>
            <th colspan="10" style="font-size:14px;text-align:center; padding:8px; border: 1px solid black;"> 
            ADVT Registration Report - Very Briefly Datewise
          </th>
        </tr>
        <tr>
          <th colspan="3" style="font-size:14px;text-align:left; padding:8px; border: 1px solid black;"> 
            हिंदुस्तान प्रकाशन संस्था-विवेक साप्ताहिक
          </th>
          <th colspan="3" style="font-size:15px; padding:8px; border: 1px solid black;">Date: From {{start_date | date:'dd-MM-yyyy'}} - To {{end_date | date:'dd-MM-yyyy'}}</th>
          <th colspan="4" style="font-size:15px;text-align:center; padding:8px; border: 1px solid black;">दिनांक: {{today1}}</th>
        </tr>
        <tr>
          <th colspan="3" style="text-align:center;font-size:15px; padding:8px; border: 1px solid black;">अंकाचे नाव: {{newissuedatepp}}</th>
          <th colspan="3" style="text-align:center;font-size:15px; padding:8px; border: 1px solid black;">अंकाची दिनांक: {{ issuedatepp | date: 'dd-MM-yyyy' }}</th>
          <th colspan="4" style="text-align:center;font-size:15px; padding:8px; border: 1px solid black;"></th>
        </tr>

        <!-- Totals Table Header -->
        <tr>
          <th style="text-align:right;font-size: 12px; padding:8px; border: 1px solid black;">Booking Date</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">No. Of Advt</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Rep Name</th>
           <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Advt Amount</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Net Amount</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Before GST Amount</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">GST Amount</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Total Amount</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Received Amount</th>
          <th style="text-align: right;font-size: 12px; padding:8px; border: 1px solid black;">Pending Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let item of inDetailsRegReportdatewise">
          <tr>
            <td style="width: 10%; text-align: center; font-size: 14px; padding:8px; border: 1px solid black;">{{item.booking_date}}</td>
           <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.advt_count}}</td>
           <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.rep_name}}</td>
           <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.total_advt_amount}}</td>
            <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.total_discounted_amt}}</td>
            <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.total_before_gst}}</td>
            <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.total_gst}}</td>
            <td style="text-align:end;width: 10%; font-size: 14px; background-color: #F7BEA2; font-weight: bold; padding:8px; border: 1px solid black;">{{item.total_amt}}</td>
            <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.total_rcv}}</td>
            <td style="text-align:end;width: 10%; font-size: 14px; padding:8px; border: 1px solid black;">{{item.total_pending}}</td>
          </tr>
        </ng-container>

        <!-- Grand Total -->
        <tr style="font-weight:bold;">
          <td style="padding:8px; border: 1px solid black;font-size: 14px;">Grand Total</td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{inDetailsRegReport1.length}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; font-weight: bold; padding:8px; border: 1px solid black;"></td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{advtamt}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{totaladvtamt}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{totalbefore_gst}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{totalgst}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; background-color: #F7BEA2; font-weight: bold; padding:8px; border: 1px solid black;">{{netadvtamt}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{jamatotal}}</td>
          <td style="text-align:end;width: 10%; font-size: 16px; padding:8px; border: 1px solid black;">{{total_pending}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Buttons for Export, Print, Close -->
  <div class="noPrint" style="margin-left: 80%; margin-bottom: 2%">
    <button type="button" mat-raised-button matTooltip="Download Excel Sheet" class="btn btn-danger"
      (click)="exportexcel('Registration Report')" style="margin-top: 2%; padding:8px;">Export</button>

    <button style="margin-top: 2%; padding:8px;" mat-raised-button color="primary" [useExistingCss]="true"
      (click)="printPageA4Portrait()">Print</button>

    <button mat-dialog-close class="btn" style="margin-top:2%; padding:8px;">Close</button>
  </div>
</div>
